<template>
  <form-group
    :errors="internalErrors"
    :label="label"
    @focus="focus"
    class="radio-group-input"
  >
    <label
      :class="{ 'uk-margin-none-left': inline,
                'radio-group-input__option--inline': inline,
                'radio-group-input__option--block': !inline }"
      class="radio-group-input__option"
      v-if="includeBlank"
    >
      <input
        :checked="hasUndefinedValue"
        :disabled="disabled"
        :name="groupName"
        :value="null"
        @change="onInput"
        class="uk-radio"
        type="radio"
      />
      <slot name="blank">{{includeBlank}}</slot>
    </label>
    <label
      :class="{ 'uk-margin-small-left': inline && !isFirstItem(index),
                'radio-group-input__option--inline': inline,
                'radio-group-input__option--block': !inline }"
      :key="index"
      class="radio-group-input__option"
      v-for="(option, index) in options"
    >
      <input
        :checked="option.value === internalValue"
        :disabled="disabled"
        :name="groupName"
        :value="option.value"
        @change="onInput"
        class="uk-radio"
        type="radio"
      />
      <slot
        :label="option.label"
        :value="option.value"
        name="option"
      >{{option.label}}</slot>
    </label>
  </form-group>
</template>

<script>
import { isNull, isUndefined } from 'lodash';
import InputWithOptions from '@/mixins/InputWithOptions';
import uuid from 'uuid/v4';

export default {
  name: 'radio-group-input',
  mixins: [InputWithOptions],
  props: {
    includeBlank: null,
    inline: {
      type: Boolean,
      default: true,
    },
  },
  computed: {
    groupName() {
      return uuid();
    },
    hasUndefinedValue() {
      return isUndefined(this.value) || isNull(this.value) || this.value === '';
    },
  },
  methods: {
    isFirstItem(index) {
      if (this.includeBlank) return false;
      return index === 0;
    },
    focus() {
      // not supported
    },
  },
};
</script>

<style lang="scss" scoped>
.radio-group-input__option--block {
  display: block;
}
</style>



// WEBPACK FOOTER //
// RadioGroupInput.vue?f07b2538